// CurrencyPicker custom element — used by currency-modal.liquid
class CurrencyPicker extends HTMLElement {
    constructor() {
        super();
        this.bindEvents();
    }

    bindEvents() {
        const localCurrency = window.localStorage.getItem("activeCurrency");
        this.currency = localCurrency || window.default_currency;

        // Listen for currency changes
        window.addEventListener("currency_changed", (event) => {
            this.currency = event.detail.currency;
            this.render();
        });

        this.render();
    }

    setCurrency(currency) {
        window.localStorage.setItem("activeCurrency", currency);
        window.dispatchEvent(
            new CustomEvent("currency_changed", {
                detail: { currency }
            })
        );
    }

    render() {
        const activeCurrencyElement = this.querySelector(".active-currency");
        if (activeCurrencyElement) {
            const currencyButton = this.querySelector(`[data-currency='${this.currency}']`);
            if (currencyButton) {
                activeCurrencyElement.innerHTML = currencyButton.innerHTML;
            }
        }
    }
}

customElements.define("currency-picker", CurrencyPicker);
